<script setup>
import moment from '@phoenix/moment';
import { computed } from 'vue';

const DATE_FORMAT = 'DD MMMM YYYY';
const DATE_SHORT_FORMAT = 'DD MMM YYYY';

const props = defineProps({
  location: {
    type: String,
    required: true,
  },
  startDate: {
    type: String,
    required: true,
  },
  endDate: {
    type: String,
    required: true,
  },
  isCard: {
    type: Boolean,
    default: false,
  },
  isList: {
    type: Boolean,
    default: false,
  },
  entryLabel: {
    type: String,
    default: '',
  },
  showEntry: {
    type: Boolean,
    default: false,
  },
  overrideDateLabel: {
    type: String,
    default: '',
  },
  classes: {
    type: Array,
    default: () => [],
  },
});

const tag = computed(() => (props.isList ? 'li' : 'div'));
const dateNow = computed(() => moment());
const startDate = computed(() => moment(props.startDate));
const endDate = computed(() => moment(props.endDate));
const isLive = computed(
  () => props.overrideDateLabel === '' && dateNow.value.isBetween(startDate.value, endDate.value, undefined, '[]'),
);
const isPast = computed(() => dateNow.value.isAfter(endDate.value));
const hasEntryLabel = computed(() => (props.overrideDateLabel !== '' || props.entryLabel !== '') && props.showEntry);
const dateLabel = computed(() => {
  if (props.overrideDateLabel !== '') {
    return props.overrideDateLabel;
  }

  if (startDate.value.isSame(endDate.value, 'day')) {
    return endDate.value.format(DATE_FORMAT);
  }

  if (startDate.value.isSame(endDate.value, 'month')) {
    return `${startDate.value.format('DD')}-${endDate.value.format(DATE_FORMAT)}`;
  }

  return `${startDate.value.format(DATE_SHORT_FORMAT)} - ${endDate.value.format(DATE_SHORT_FORMAT)}`;
});
</script>

<template>
  <component
    :is="tag"
    class="event"
    :class="[
      { 'event--line': !isCard, 'event--card': isCard, 'event--live': isLive, 'event--past': isPast },
      ...props.classes,
    ]"
  >
    <div v-if="hasEntryLabel" class="event__entry">{{ entryLabel }}</div>
    <div class="event__location">{{ location }}</div>
    <div class="event__date">
      <span>
        {{ dateLabel }}
        <span v-if="isLive" class="pulse event__pulse"></span>
      </span>
    </div>
  </component>
</template>
